import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { VacationRessProperties } from "./annualVacationView";
import { PageTitleProps } from "../core/components/pageTitle";
import React from "react"
export interface AnnualVacationEditAppProps extends AppBaseProps {
    entity: VacationRessProperties
}

export class AnnualVacationEditApp extends React.Component<AnnualVacationEditAppProps, any> {
    common = new AppHelper();
    translations = [];
    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        const model: string = field.model;
        switch (model) {
            case ("entity.Jahresurlaub"):
                this._updateEntity(value, null, null);
                break;
            case ("entity.SonderUrlaub"):
                this._updateEntity(null, value, null);
                this._resetSonderGrund(value);
                break;
            case ("entity.RestUrlaubVorjahr"):
                this._updateEntity(null, null, value);
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = async (closeAfterSave) => {
        if (this.common.validate()) {
            let result = await HTTPService.post<JsonResultClass<VacationRessProperties>>("Vacation/Save", this.props.entity);
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                this.common.setEntityDirtyState(false);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    getRemainingVacation = async () => {
        let result = await HTTPService.get<JsonResultClass<VacationRessProperties>>("Vacation/GetVacation", { ressNr: this.props.entity.RessNr, year: this.props.entity.Jahr - 1 })
        if (result.Code == 0) {
            this.handleFieldChange({ model: "entity.RestUrlaubVorjahr" }, result.Data.VerfuegbarerUrlaub);
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private _updateEntity = (demandVacation: number = null, specialVacation: number = null, remainingVacation: number = null) => {
        let newEntity = this.props.entity;

        newEntity.Jahresurlaub = Helper.getValueOrDefault(demandVacation, this.props.entity.Jahresurlaub);
        newEntity.SonderUrlaub = Helper.getValueOrDefault(specialVacation, this.props.entity.SonderUrlaub);
        newEntity.RestUrlaubVorjahr = Helper.getValueOrDefault(remainingVacation, this.props.entity.RestUrlaubVorjahr);

        newEntity.GesamterUrlaub = newEntity.Jahresurlaub + newEntity.SonderUrlaub + newEntity.RestUrlaubVorjahr;

        newEntity.VerfuegbarerUrlaub = newEntity.GesamterUrlaub - newEntity.Geplant - newEntity.GenehmigterUrlaub;


        Helper.updateEntity(this.props.entity, newEntity);
        this.setState({});

    }

    private _resetSonderGrund = (value: any) => {

        if (value == 0) {
            let newEntity = this.props.entity;
            newEntity.SonderUrlaubGrund = "";
            Helper.updateEntity(this.props.entity, newEntity);
            this.setState({});
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        const titleProps: PageTitleProps = {
            title: this.props.title
        };
        return <CommonApp {...props} titleProps={titleProps} />;
    }
}